import InfoPages from "../index";
import PageTitle from "../../../ui/PageTitle";
import MESSAGES from "../../../constants/messages";

const TermsAndCondition = () => {
  return (
    <InfoPages>
      <PageTitle title={MESSAGES.TERM_AND_CONDITION}/>

      <p><strong>Effective Date:</strong> May 14, 2026</p>

      <p>
        These Terms & Conditions govern your use of <strong>ucr-registration.org</strong> (“Website”)
        and services provided by <strong>United Carrier Route Compliance</strong>
        (“Company,” “we,” “our,” or “us”).
      </p>

      <h2>1. Independent Third-Party Service Provider Disclaimer</h2>
      <p>
        United Carrier Route Compliance is a private third-party filing and compliance assistance company
        and is not affiliated with, endorsed by, or acting on behalf of the Federal Motor Carrier Safety
        Administration (FMCSA), Unified Carrier Registration (UCR), Department of Transportation (DOT),
        Oregon Department of Transportation (ODOT), or any government agency.
      </p>

      <p>We assist customers with transportation compliance filings and registration-related services.</p>

      <h2>2. Services Provided</h2>
      <ul style={{marginLeft: "40px"}}>
        <li>UCR Registration Assistance</li>
        <li>Transportation Compliance Support</li>
        <li>Carrier Registration Assistance</li>
        <li>Permit Filing Assistance</li>
      </ul>

      <h2>3. Customer Authorization & Third-Party Filing Services</h2>
      <p>By submitting an order and proceeding with services through our website, the customer acknowledges and agrees
        that:</p>
      <ul style={{marginLeft: "40px"}}>
        <li>United Carrier Route Compliance acts as a third-party filing and compliance assistance provider;</li>
        <li>The customer voluntarily engages our services;</li>
        <li>The customer authorizes us to assist with filings, registrations, permits, and compliance-related
          submissions on their behalf;
        </li>
        <li>The customer certifies that all information submitted is accurate and authorized for use.</li>
      </ul>

      <p>
        The customer understands that filing outcomes, approvals, and timelines are determined solely
        by applicable agencies and not by United Carrier Route Compliance.
      </p>

      <h2>4. Customer Responsibilities</h2>
      <ul style={{marginLeft: "40px"}}>
        <li>Provide complete and accurate information</li>
        <li>Review submitted information prior to purchase</li>
        <li>Ensure all submitted information is authorized for use</li>
        <li>Cooperate with any requests necessary to complete filings</li>
      </ul>

      <p>
        United Carrier Route Compliance is not responsible for delays, penalties, or filing issues caused
        by incomplete or inaccurate customer information.
      </p>

      <h2>5. Payment Terms</h2>
      <p>
        Payments are securely processed through approved third-party payment processors.
        Customers complete payments through the website checkout flow and are not billed manually.
      </p>

      <p>
        Charges may appear on bank or card statements as
        <strong>“United Carrier Route Compliance”</strong> or a similar billing descriptor.
      </p>

      <p>
        The Company reserves the right to decline or cancel orders where fraud, inaccurate information,
        payment concerns, or suspicious activity is suspected.
      </p>

      <h2>6. Pricing Errors</h2>
      <p>
        In the event of a typographical, technical, or pricing error on the website, the Company reserves
        the right to correct pricing and cancel or refuse orders submitted using inaccurate pricing.
      </p>

      <p>If payment has already been made and the order cannot be fulfilled, the Company may issue an appropriate
        refund.</p>

      <h2>7. No Guarantee of Approval</h2>
      <p>United Carrier Route Compliance does not guarantee:</p>
      <ul style={{marginLeft: "40px"}}>
        <li>Government approval</li>
        <li>Processing timelines</li>
        <li>Acceptance of filings</li>
        <li>Permit issuance outcomes</li>
      </ul>

      <p>Government agencies retain sole authority over approvals and compliance decisions.</p>

      <h2>8. Limitation of Liability</h2>
      <p>United Carrier Route Compliance shall not be liable for:</p>
      <ul style={{marginLeft: "40px"}}>
        <li>Government delays</li>
        <li>Filing rejections</li>
        <li>Lost profits</li>
        <li>Business interruption</li>
        <li>Penalties arising from incorrect customer information</li>
        <li>Indirect or consequential damages</li>
      </ul>

      <h2>9. Changes to Terms</h2>
      <p>
        We reserve the right to revise these Terms & Conditions at any time without prior notice.
        Continued use of the Website constitutes acceptance of any updated Terms.
      </p>

      <h2>10. Governing Law</h2>
      <p>These Terms shall be governed by the laws of the State of California.</p>

      <h2>11. Contact Information</h2>
      <p>
        <strong>United Carrier Route Compliance</strong><br/>
        6817 Foothill Blvd<br/>
        Tujunga, CA 91042<br/>
        Website: <a href="https://ucr-registration.org">https://ucr-registration.org</a><br/>
        Email: <a href="mailto:support@ucr-registration.org">support@ucr-registration.org</a>
      </p>
    </InfoPages>
  );
};

export default TermsAndCondition;
